import React from 'react';
import AGrid from 'antd-mobile/lib/grid';



export default class Grid extends AGrid {}